const styles = {
    button: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        borderRadius: '16px',
        fontSize: '16px',
        textTransform: 'none',
        marginTop: '40px',
        backgroundColor: '#3876AA',
        color: '#FFFFFF',
    },
    error_message: {
        marginTop: '24px',
        color: '#ED0000',
        fontFamily: 'Silka_Regular',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
    },
};
export default styles;
